import React, { Suspense } from 'react';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import store, { history } from 'app/store';
import * as types from 'app/actions/action_types';
import { Link } from 'react-router-dom';

import withMobileDetecting from 'app/components/HOGs/detectMobileDesign';
import { Skeleton } from 'antd';
import { FormattedMessage } from 'react-intl';

import YouTubeRed from 'static/img/header/YouTube_Red.svg';
import { move } from '../../../actions/Map/move.point.action';
import { mapPositionToPoint } from '../../../actions/Map/display.point.action';
import {
  openModalTourDownload,
  openTourDownloadBasket,
  TourDownloadCoord,
} from '../../../actions/TourDownload/tourDownloadGps.action';
// Router
import { mainMenuCollapse } from '../../../actions/Menu/main_menu.action';

// CSS
import './navbar.css';

import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher.container';
import TourstartAcademy from '../TourstartAcademy/academy';

// IMAGE

import { ErrorBoundary } from '../../Utility/errorBoundary';
import MainLogo from './mainLogo';

import { retry } from '../../Utility/loadingChunkErrorHandler';

import { ProIcon, HelpIcon } from '../MainMenu/svg';

// TODO Please rename Sign component to Login
const Login = React.lazy(() =>
  retry(() => import(/* webpackChunkName: "login" */ '../Sign/sign-up'))
);
const MainSearch = React.lazy(() =>
  retry(() => import(/* webpackChunkName: "search" */ '../Search/mainSearch'))
);
const DownloadTourGpsContainer = React.lazy(() =>
  retry(() =>
    import(
      /* webpackChunkName: "download" */ '../downloadGps/downloadGps.container'
    )
  )
);

const getAcademyFromStrSearch = (str) => {
  const index = str.indexOf('academy');
  return index > -1;
};

class NavBar extends React.Component {
  constructor(props) {
    super(props);
    this.dowmloadGpsRef = React.createRef();
    this.state = {
      showAcademy: false,
    };
  }

  handleLogoClick = () => {
    history.push('/');
    store.dispatch(mainMenuCollapse(true));
    store.dispatch({
      type: types.USER_CHANGE_INDEX_VALUE,
      payload: 0,
    });
  };

  getLinkToAcademy = () =>
    `${this.props.router.location.pathname}?scope=academy`;

  componentDidMount() {
    if (getAcademyFromStrSearch(this.props.router.location.search)) {
      this.setState({ showAcademy: true });
    }
  }

  setAcademy = (link) => {
    this.setState({
      showAcademy: getAcademyFromStrSearch(link),
    });
  };

  componentDidUpdate(prevProps) {
    if (
      this.props.router.location.search !== prevProps.router.location.search
    ) {
      this.setAcademy(this.props.router.location.search);
    }
  }

  render() {
    return this.props.isMobileDesign ? null : (
      <>
        <div className="socialBlockLayout">
          <MainLogo handleLogoClick={this.handleLogoClick} />
          <Suspense
            fallback={
              <Skeleton
                size="large"
                title={false}
                paragraph={{
                  rows: 1,
                  width: window.innerWidth < 1200 ? '260px' : '460px',
                }}
                className="main-search-skeleton"
              />
            }
          >
            <ErrorBoundary
              errorView={() => {
                return (
                  <div
                    style={{
                      width: window.innerWidth < 1200 ? '300px' : '500px',
                    }}
                  />
                );
              }}
            >
              <MainSearch />
            </ErrorBoundary>
          </Suspense>

          <Suspense
            fallback={
              <Skeleton
                size="large"
                title={false}
                paragraph={{ rows: 1, width: '78px' }}
                className="dowload-gps-button-skeleton"
              />
            }
          >
            <ErrorBoundary errorView={<div style={{ width: '118px' }} />}>
              <DownloadTourGpsContainer />
            </ErrorBoundary>
          </Suspense>

          <div className="header_buttons">
            <a
              href="https://www.youtube.com/@Tourstart"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="youtube_layout">
                <img src={YouTubeRed} alt="" className="img" />
                <span className="text">YouTube</span>
              </div>
            </a>

            <Link to="/pro">
              <div className="pricing">
                <ProIcon />
                <span className="title">
                  <FormattedMessage id="Pricing" defaultMessage="Pricing" />
                </span>
              </div>
            </Link>

            <Link to="/faq">
              <div className="help">
                <HelpIcon />
                <span className="title">
                  <FormattedMessage id="Help" defaultMessage="Help" />
                </span>
              </div>
            </Link>

            <LanguageSwitcher />

            <div className="loginLayout">
              <Suspense
                fallback={
                  <Skeleton
                    size="large"
                    title={false}
                    paragraph={{ rows: 1, width: '50px' }}
                    className="login-button-skeleton"
                  />
                }
              >
                <Login />
              </Suspense>
            </div>
          </div>
        </div>
        {this.state.showAcademy ? <TourstartAcademy /> : null}
      </>
    );
  }
}

NavBar.displayName = 'NavBar';

const mapStateToProps = (store) => {
  return {
    dataSearch: store.searchBarData,
    downloadTourGps: store.tourDownload,
    router: store.router,
    userData: store.authentication.user,
  };
};
const matchDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      move,
      mapPositionToPoint,
      openModalTourDownload,
      openTourDownloadBasket,
      TourDownloadCoord,
      mainMenuCollapse,
    },
    dispatch
  );
};
export default connect(
  mapStateToProps,
  matchDispatchToProps
)(withMobileDetecting(NavBar));
